// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { IStackTokens } from '@fluentui/react';

/**
 * @private
 */
export const videoGalleryLayoutGap: IStackTokens = {
  childrenGap: '0.5rem'
};